import { useMemo } from "react";
import { useInMemorySearch } from "../../common/domain/service";
import { useEnabledLensSources } from "../../lens-source/hooks";
import { useSelectedOrganization } from "../../organizations/hooks";
import { useLoadLensesV2 } from "./useLoadLensesV2";

export const useAllLensesV2 = () => {
    const { lenses, loading: areLensesLoading, loadMore, isLastPage, error: loadLensesError } = useLoadLensesV2();
    const { selectedOrganizationId } = useSelectedOrganization();
    const {
        isAnySourceEnabled,
        loading: isLensSourceListLoading,
        error: lensSourceListError,
    } = useEnabledLensSources();

    const { searchService, setSearchValue } = useInMemorySearch();

    const searchResults = useMemo(
        () => searchService.applyFilter(lenses, (lens) => lens.name),
        [lenses, searchService],
    );

    return {
        search: searchService.maybeFilter,
        setSearch: setSearchValue,
        lenses: searchResults,
        loading: areLensesLoading || isLensSourceListLoading,
        error: lensSourceListError || loadLensesError,
        loadMore,
        isLastPage,
        selectedOrganizationId,
        isAnySourceEnabled,
    };
};
